import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { get, put } from "../../services/Services"; // Asegurate de tener la función PUT
import { FaSave, FaTimesCircle } from "react-icons/fa";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from "react-toastify";

const COURSE_LEVELS_URL = "https://ectech-software.com.ar/api/academy/course-level";
const COURSE_TYPES_URL = "https://ectech-software.com.ar/api/academy/course-types";

function CoursesEditAdm({ courseToEdit, ConfigId, setShowForm, refetch }) {
  const [formData, setFormData] = useState({
    name: "",
    typeId: "",
    status: false,
    teacher: "",
    courseDate: "",
    levelId: "",
    price: "",
  });

  const [courseLevels, setCourseLevels] = useState([]);
  const [courseTypes, setCourseTypes] = useState([]);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Cargar niveles y tipos
  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const [levelsResponse, typesResponse] = await Promise.all([
          get(COURSE_LEVELS_URL),
          get(COURSE_TYPES_URL)
        ]);
        if (Array.isArray(levelsResponse.data)) setCourseLevels(levelsResponse.data);
        if (Array.isArray(typesResponse.data)) setCourseTypes(typesResponse.data);
      } catch (err) {
        console.error("Error cargando niveles/tipos:", err);
      }
    };

    fetchOptions();
  }, []);

  // Inicializar con datos del curso a editar
  useEffect(() => {
    if (courseToEdit) {
      setFormData({
        name: courseToEdit.name || "",
        typeId: courseToEdit.type?.id || "",
        status: courseToEdit.status ? 1 : 0,
        teacher: courseToEdit.teacher || "",
        courseDate: courseToEdit.courseDate?.substring(0, 10) || "",
        levelId: courseToEdit.level?.id || "",
        price: courseToEdit.price ?? "",

      });
    }
  }, [courseToEdit]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setErrors({});

    const dataToSend = {
      name: formData.name,
      status: Boolean(formData.status),
      teacher: formData.teacher,
      type: { id: parseInt(formData.typeId) },
      courseDate: formData.courseDate,
      level: { id: parseInt(formData.levelId) },
      price: parseFloat(formData.price)
    };

    try {
      await put(
        `https://ectech-software.com.ar/api/academy/events/${ConfigId}/courses/${courseToEdit.id}`,
        dataToSend
      );
      toast.success("Modificado correctamente");
      refetch();
      setShowForm(false);
    } catch (error) {
      console.error("Error al actualizar el curso:", error);
      setErrors({ general: "Hubo un error al actualizar el curso." });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="container mt-4">
      <div className="card shadow-lg p-4 w-100" style={{ maxWidth: "600px", margin: "auto" }}>
        <div className="card-header bg-warning text-white text-center">
          <h5 className="mb-0">Editar Curso</h5>
        </div>
        <div className="card-body">
          {errors.general && <div className="alert alert-danger">{errors.general}</div>}
          <form onSubmit={handleSubmit}>
            {/* Campos similares al formulario de creación */}
            {/* Reutilizamos la lógica */}
            <div className="mb-3">
              <label className="form-label">Nombre</label>
              <input type="text" name="name" className="form-control" value={formData.name} onChange={handleChange} required />
            </div>

            <div className="mb-3">
              <label className="form-label">Tipo de Curso</label>
              <select name="typeId" className="form-control" value={formData.typeId} onChange={handleChange} required>
                <option value="">Seleccione un tipo...</option>
                {courseTypes.map((type) => (
                  <option key={type.id} value={type.id}>{type.name}</option>
                ))}
              </select>
            </div>

            <div className="mb-3">
              <label className="form-label">Profesor /a</label>
              <input type="text" name="teacher" className="form-control" value={formData.teacher} onChange={handleChange} required />
            </div>

            <div className="mb-3">
              <label className="form-label">Fecha del Curso</label>
              <input type="date" name="courseDate" className="form-control" value={formData.courseDate} onChange={handleChange} required />
            </div>

            <div className="mb-3">
              <label className="form-label">Nivel del Curso</label>
              <select name="levelId" className="form-control" value={formData.levelId} onChange={handleChange} required>
                <option value="">Seleccione un nivel...</option>
                {courseLevels.map((level) => (
                  <option key={level.id} value={level.id}>{level.name}</option>
                ))}
              </select>
            </div>

            <div className="mb-3">
              <label className="form-label">Precio</label>
              <input type="number" name="price" className="form-control" value={formData.price} onChange={handleChange} required />
            </div>

            <div className="form-check form-switch mb-3">
              <input
                type="checkbox"
                id="status"
                name="status"
                className="form-check-input"
                checked={!!formData.status}
                onChange={(e) => setFormData((prev) => ({ ...prev, status: e.target.checked ? 1 : 0 }))}
              />
              <label className="form-check-label" htmlFor="status">
                {formData.status ? "Activado" : "Desactivado"}
              </label>
            </div>

            <div className="d-flex justify-content-between">
              <button type="submit" className="btn btn-warning" disabled={isSubmitting}>
                <FaSave /> {isSubmitting ? "Actualizando..." : "Actualizar"}
              </button>
              <button type="button" className="btn btn-secondary" onClick={() => setShowForm(false)}>
                <FaTimesCircle /> Cancelar
              </button>
            </div>
          </form>
        </div>
        <ToastContainer 
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
          />
      </div>
      
    </div>
  );
}

export default CoursesEditAdm;
